const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");

const Reflux = require("reflux");
const ForgottenOrganizationsStore = require("../../stores/forgotten-organizations-store");
const ForgottenOrganizationsActions = require("../../actions/forgotten-organizations-actions");

const Chart = require("../Dashboard/Chart/chart");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const ForgottenOrganizationsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return ForgottenOrganizationsStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(ForgottenOrganizationsStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    ForgottenOrganizationsActions.fetchData(
      this.props.users
    );
  },

  chartDatasets: function() {
    return (
      [
        {
          label: "Nunca trabalhados",
          data: this.state.data.forgottenOrganizations.map(item => item.notWorked.percentage),
          backgroundColor: "#6F6E9A",
          borderColor: "#6F6E9A"
        },
        {
          label: "Última atividade há mais de 30 dias",
          data: this.state.data.forgottenOrganizations.map(item => item.moreThirtyDays.percentage),
          backgroundColor: "#A2C7BD",
          borderColor: "#A2C7BD"
        },
      ]
    )
  },

  getDetailsUrl: function(id, datasetIndex) {
    let searchParams = new URLSearchParams();
    let forgottenState = "";

    if (datasetIndex === 0) {
      forgottenState = "noActivity";
    }
    else {
      forgottenState = "noRecentActivity";
    }

    searchParams.append("ur", id);
    searchParams.append("forgotten", forgottenState);

    return `${betaURL()}/organizations?${searchParams}`;
  },

  render: function() {
    const chartHeight = 100 + this.state.data.forgottenOrganizations.length * 30;

    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Quem está <strong>esquecendo dos clientes</strong> da carteira?</p>
        }
        className="grid-item-col-2"
      >
        <div className="h-280 ovy-auto thinScrollbar">
          <Chart
            type="horizontalBar"
            plugins={[ChartDataLabels]}
            datasets={this.chartDatasets()}
            labels={this.state.data.forgottenOrganizations.map(item => (
              item.user.name || "Usuário sem nome"
            ))}
            style={{ height: Math.max(chartHeight, 220) }}
            options={{
              maintainAspectRatio: false,
              legend: {
                labels: {
                  boxWidth: 16
                }
              },
              scales: {
                xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: "PERCENTUAL DE EMPRESAS ESQUECIDAS",
                    fontSize: 11,
                    fontStyle: "bold"
                  },
                  position: "top",
                  stacked: true,
                  gridLines: {
                    display: false,
                    drawBorder: false
                  },
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  stacked: true,
                  barThickness: 25,
                  gridLines: {
                    display: false,
                    drawBorder: false
                  }
                }]
              },
              tooltips: {
                displayColors: true,
                callbacks: {
                  beforeBody: (tooltipItem, data) => {
                    const itemData = this.state.data.forgottenOrganizations[tooltipItem[0].index];
                    const total = itemData.total;
                    const totalPercentage = (itemData.notWorked.percentage + itemData.moreThirtyDays.percentage).toFixed(1) + "%";
                    const totalForgotten = itemData.notWorked.count + itemData.moreThirtyDays.count;

                    return ([
                      `Responsável por ${total} empresas.`,
                      `${totalPercentage} (${totalForgotten}) estão sendo esquecidas.`,
                      ""
                    ]);
                  },
                  label: (tooltipItem, data) => {
                    // Linha de nunca trabalhados
                    if (tooltipItem.datasetIndex === 0) {
                      const notWorked = this.state.data.forgottenOrganizations[tooltipItem.index].notWorked.count;
                      return data.datasets[tooltipItem.datasetIndex].label + ": " + notWorked + " empresas";
                    }
                    else { // Linha de ultimos 30 dias
                      const moreThirtyDays = this.state.data.forgottenOrganizations[tooltipItem.index].moreThirtyDays.count;
                      return data.datasets[tooltipItem.datasetIndex].label + ": " + moreThirtyDays + " empresas";
                    }
                  }
                }
              },
              hover: {
                intersect: true,
                mode: "nearest"
              },
              onHover: (event, elements) => {
                if (elements.length > 0) {
                  event.target.style.setProperty("cursor", "pointer");
                } else {
                  event.target.style.removeProperty("cursor");
                }
              },
              onClick: (_, [element]) => {
                if (element) {
                  const datasetIndex = element._datasetIndex
                  const item = this.state.data.forgottenOrganizations[element._index];

                  window.open(this.getDetailsUrl(item.user.id, datasetIndex), "_blank")
                }
              },
              plugins: {
                datalabels: {
                  formatter: function (value, ctx) {
                    let visibleDatasets = ctx.chart.data.datasets.filter(
                      (_, datasetIndex) => ctx.chart.isDatasetVisible(datasetIndex)
                    );

                    if (visibleDatasets.indexOf(ctx.dataset) === visibleDatasets.length - 1) {
                      let totalPercentage = visibleDatasets.reduce((sum, dataset) => {
                        return sum + dataset.data[ctx.dataIndex];
                      }, 0);

                      if (Number.isInteger(totalPercentage))
                        return totalPercentage + "%";
                      else
                        return totalPercentage.toFixed(1) + "%";
                    }
                    else {
                      return "";
                    }
                  },
                  anchor: "end",
                  align: "end"
                }
              }
            }}
          />
        </div>
      </CardWithLoader>
    )
  }
})

module.exports = ForgottenOrganizationsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/forgotten-organizations-widget.jsx